// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"9f9c8120","66":"8064b9e6","145":"d19b58cc","190":"38d50f46","613":"74fe177b","906":"d781ce59","948":"16081ff3","957":"f606cbeb","969":"63267e3b"}[chunkId] + ".chunk.js";
};